import { render, staticRenderFns } from "./NoTicket.vue?vue&type=template&id=d7ed80fc&scoped=true&"
import script from "./NoTicket.vue?vue&type=script&lang=ts&"
export * from "./NoTicket.vue?vue&type=script&lang=ts&"
import style0 from "./NoTicket.vue?vue&type=style&index=0&id=d7ed80fc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7ed80fc",
  null
  
)

export default component.exports